import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    slots: [],
    loading: true,
    error: null,
};
export const meetingSlotsSlice = createSlice({
    name: 'meetingSlots',
    initialState,
    reducers: {
        fetchMeetingSlotsRequest(state, _action) {
            state.loading = true;
        },
        fetchMeetingSlotsSuccess(state, action) {
            state.loading = false;
            state.slots = action.payload;
        },
        bookSlotRequest(_state, _action) {
            // No-op implementation for initial state
        },
    },
});
export const { fetchMeetingSlotsRequest, fetchMeetingSlotsSuccess, bookSlotRequest } = meetingSlotsSlice.actions;
export default meetingSlotsSlice.reducer;
